import { LazyLoadImageModule } from 'ng-lazyload-image';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ResizeService } from '../../../../../services/resize.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-banner',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule, RouterModule, LazyLoadImageModule, NgOptimizedImage],
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.scss'
})
export class BannerComponent {
  faArrowRight = faArrowRight;
  constructor(public resize:ResizeService){}
}
